"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerItem = _interopRequireDefault(require("./CustomerItem.vue"));
var _customer = require("@/api/customer.api");
var ApartmentAddCustomerModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ApartmentAddCustomerModal, _Vue);
  var _super = (0, _createSuper2.default)(ApartmentAddCustomerModal);
  function ApartmentAddCustomerModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ApartmentAddCustomerModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "apartmentId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "search", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "customers", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectedCustomer", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingSubmit", false);
    return _this;
  }
  (0, _createClass2.default)(ApartmentAddCustomerModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return this.selectedCustomer;
    }
  }, {
    key: "handleClickCustomer",
    value: function handleClickCustomer(customer) {
      debugger;
      this.selectedCustomer = customer;
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "handleChoose",
    value: function () {
      var _handleChoose = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                debugger;
                this.loadingSubmit = true;
                _context.prev = 2;
                data = {
                  customer: (0, _objectSpread2.default)({}, this.selectedCustomer),
                  apartmentId: this.apartmentId
                };
                _context.next = 6;
                return _customer.customerApi.update(this.selectedCustomer.id, data);
              case 6:
                this.visible = false;
                this.onSubmitOk();
                this.$notify({
                  title: "Thông báo",
                  message: "Chỉnh sửa khách hàng thành công",
                  type: "success"
                });
              case 9:
                _context.prev = 9;
                this.loadingSubmit = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 9, 12]]);
      }));
      function handleChoose() {
        return _handleChoose.apply(this, arguments);
      }
      return handleChoose;
    }()
  }, {
    key: "fetchCustomers",
    value: function () {
      var _fetchCustomers = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;
                _context2.next = 3;
                return _customer.customerApi.findAll({
                  buildingId: this.buildingId,
                  search: this.search,
                  page: 1,
                  limit: 20
                });
              case 3:
                res = _context2.sent;
                this.loading = false;
                this.customers = res.data.customers;
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function fetchCustomers() {
        return _fetchCustomers.apply(this, arguments);
      }
      return fetchCustomers;
    }()
  }, {
    key: "handleOpen",
    value: function handleOpen(customer) {
      this.selectedCustomer = customer;
      this.fetchCustomers();
      this.visible = true;
    }
  }]);
  return ApartmentAddCustomerModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentAddCustomerModal.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentAddCustomerModal.prototype, "apartmentId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], ApartmentAddCustomerModal.prototype, "onSubmitOk", null);
ApartmentAddCustomerModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerItem: _CustomerItem.default
  }
})], ApartmentAddCustomerModal);
var _default = ApartmentAddCustomerModal;
exports.default = _default;